'use strict';
import {Injectable} from 'ng-metadata/core';

@Injectable()
export class PnxUtil {

	public getValue(result, section, key, defaultValue = ''){
		return this.getArrayValue(result, section, key,null)[0] || defaultValue;
	}

	public getArrayValue(result, section, key, defaultValue = []){
		if(!result.pnx || !result.pnx[section]){
			return defaultValue;
		}
		return result.pnx[section][key] || defaultValue;
	}
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/pnxUtil.service.ts